"use client"
import { parseAsJson, useQueryState } from "nuqs"
import { z } from "zod"
import { QUERY_PARAM_KEYS } from "./keys"

const schema = z.array(
  z.object({
    traitType: z.string(),
    min: z.float64(),
    max: z.float64(),
  }),
)

export function useNumericTraitsQueryParam() {
  const [values, setValues] = useQueryState(
    QUERY_PARAM_KEYS.numericTraits,
    parseAsJson(schema.parse).withDefault([]),
  )

  async function onSelectNumericTrait(
    traitType: string,
    min: number,
    max: number,
  ) {
    const updatedTraits = values.some(trait => trait.traitType === traitType)
      ? values.map(trait =>
          trait.traitType === traitType ? { traitType, min, max } : trait,
        )
      : [...values, { traitType, min, max }]

    await setValues(updatedTraits)
  }

  async function onRemoveNumericTrait(traitType: string) {
    const newValues = values.filter(trait => trait.traitType !== traitType)
    await setValues(newValues.length > 0 ? newValues : null)
  }

  return { numericTraits: values, onSelectNumericTrait, onRemoveNumericTrait }
}
